import React, { useState, useEffect } from "react";
import {
  Tree,
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  message,
  Card,
  Row,
  Col,
  Popconfirm,
  Select,
  Divider,
} from "antd";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  FolderOutlined,
  FileOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import httpUtil from "../../../../utils/httpUtil";

const { TextArea } = Input;
const { Option } = Select;

export const Indictors = () => {
  const [treeData, setTreeData] = useState([]);
  const [indicatorMap, setIndicatorMap] = useState({});
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [selectedNode, setSelectedNode] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("新增指标");
  const [formMode, setFormMode] = useState("add"); 
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // 获取指标数据
  const getAllIndicators = async () => {
    setLoading(true);
    try {
      httpUtil.getAllIndicators().then((res) => {
        if (res.success) {
          setTreeData(res.data);
          matchParent();
        } else {
          message.error(res.error);
        }
      });
      setLoading(false);
    } catch (error) {
      message.error("获取指标数据失败");
      setLoading(false);
    }
  };
  //创建父级id和名称对应关系
  const matchParent = () => {
    // 创建指标ID到名称的映射表
    const map = {};
    const buildMap = (items) => {
      items.forEach((item) => {
        map[item.indicator_id] = item.indicator_name;
        if (item.children) {
          buildMap(item.children);
        }
      });
    };
    buildMap(treeData);
    setIndicatorMap(map);
  };

  useEffect(() => {
    getAllIndicators();
  }, []);

  // 展开/收起节点
  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys);
  };

  // 选择节点
  const onSelect = (selectedKeys, { selected, node }) => {
    setSelectedKeys(selectedKeys);
    if (selected) {
      setSelectedNode(node);
      console.log(node);
    } else {
      setSelectedNode(null);
    }
  };

  // 打开新增模态框
  const showAddModal = () => {
    setFormMode("add");
    setModalTitle("新增指标");
    form.resetFields();
    form.setFieldsValue({
      parent_id: selectedNode ? selectedNode.indicator_id : null,
    });
    setModalVisible(true);
  };

  // 打开编辑模态框
  const showEditModal = () => {
    if (!selectedNode) {
      message.warning("请先选择一个指标");
      return;
    }

    setFormMode("edit");
    setModalTitle("编辑指标");
    form.setFieldsValue({
      ...selectedNode,
      parent_id: selectedNode.parent_id || null,
    });
    setModalVisible(true);
  };

  // 提交表单
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const indicator_id = `IND_${Date.now().toString().slice(-6)}`;

      if (formMode === "add") {
        const paramas = {
          ...values,
          indicator_id,
        };

        httpUtil.addIndicator(paramas).then((res) => {
          if (res.success) {
            message.success(res.message);
            form.resetFields();
            getAllIndicators();
          } else {
            message.error(res.error); // 处理业务逻辑错误
          }
        });
      } else if (formMode === "edit") {
        const parmas = {
          ...values,
          indicator_id: selectedNode.indicator_id,
        };
        httpUtil.updateIndicator(parmas).then((res) => {
          if (res.success) {
            message.success(res.message);
            form.resetFields();
            getAllIndicators();
            //更新详情
            setSelectedNode({
              ...selectedNode,
              ...values
            });
          } else {
            message.error(res.error); // 处理业务逻辑错误
          }
        });
      }

      setModalVisible(false);
      getAllIndicators();
    } catch (error) {
      console.error("提交失败:", error);
      setLoading(false);
    }
  };

  // 删除指标
  const handleDelete = async () => {
    if (!selectedNode) {
      message.warning("请先选择一个指标");
      return;
    }

    try {
      setLoading(true);
      const params = { indicator_id: selectedNode.indicator_id };
      console.log(params);
      httpUtil.deleteIndicator(params).then((res) => {
        if (res.success) {
          message.success(res.message);
          setSelectedKeys([]);
          setSelectedNode(null);
          getAllIndicators();
        } else {
          message.error(res.error); // 处理业务逻辑错误
        }
      });
    } catch (error) {
      message.error("删除指标失败");
      setLoading(false);
    }
  };

  // 渲染树节点标题
  const renderTitle = (node) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <span>{node.indicator_name}</span>
        <span style={{ color: "#888" }}>
          ···权重: {(node.weight * 100).toFixed(3)}%
        </span>
      </div>
    );
  };

  // 转换树数据
  const convertTreeData = (data) => {
    return data.map((item) => ({
      indicator_id: item.indicator_id,
      indicator_name: item.indicator_name,
      weight: item.weight,
      description: item.description,
      parent_id: item.parent_id,
      applicant_type: item.applicant_type,
      isLeaf: !item.children || item.children.length === 0,
      children: item.children ? convertTreeData(item.children) : [],
      icon: item.children ? <FolderOutlined /> : <FileOutlined />,
    }));
  };

  // 获取所有一级指标作为父级选项
  const getParentOptions = () => {
    return treeData.filter((item) => !item.parent_id);
  };

  return (
    <div style={{ paddingTop: "24px" }}>
      <Card
        title="评价指标管理"
        variant={false}
        style={{ maxHeight: "80vh", border: 0 }}
        extra={
          <div>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={showAddModal}
              style={{ marginRight: 8 }}
            >
              新增
            </Button>
            <Button
              icon={<EditOutlined />}
              onClick={showEditModal}
              style={{ marginRight: 8 }}
              disabled={!selectedNode}
            >
              编辑
            </Button>
            <Popconfirm
              title="确定要删除这个指标吗？"
              onConfirm={handleDelete}
              okText="确定"
              cancelText="取消"
            >
              <Button icon={<DeleteOutlined />} danger disabled={!selectedNode}>
                删除
              </Button>
            </Popconfirm>
          </div>
        }
      >
        <Row gutter={16}>
          <Col span={12}>
            <div style={{ height: "calc(90vh - 200px)", overflow: "auto" }}>
              <Tree
                showIcon
                expandedKeys={expandedKeys}
                selectedKeys={selectedKeys}
                onExpand={onExpand}
                onSelect={onSelect}
                treeData={convertTreeData(treeData)}
                titleRender={renderTitle}
                loading={loading}
              />
            </div>
          </Col>
          <Col span={12}>
            {selectedNode ? (
              <Card
                title="指标详情"
                extra={
                  <Button
                    type="text"
                    icon={<CloseOutlined />}
                    onClick={() => {
                      setSelectedKeys([]);
                      setSelectedNode(null);
                    }}
                  />
                }
              >
                <Divider orientation="left">基本信息</Divider>
                <p>
                  <strong>指标名称：</strong>
                  {selectedNode.indicator_name}
                </p>
                <p>
                  <strong>权重：</strong>
                  {(selectedNode.weight * 100).toFixed(3)}%
                </p>
                <p>
                  <strong>指标ID：</strong>
                  {selectedNode.indicator_id}
                </p>
                <p>
                  <strong>父级指标名称：</strong>
                  {/* {selectedNode.parent_id ? indicatorMap[selectedNode.parent_id] || "未知" : "无"} */}
                  {selectedNode.parent_id ? selectedNode.parent_id : "无"}
                </p>
                <p>
                  <strong>评价人类型：</strong>
                  {selectedNode.applicant_type
                    ? selectedNode.applicant_type
                    : "管理员"}
                </p>

                <Divider orientation="left">指标描述</Divider>
                <p>{selectedNode.description || "暂无描述"}</p>
              </Card>
            ) : (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#888",
                }}
              >
                请从左侧选择一个指标查看详情
              </div>
            )}
          </Col>
        </Row>
      </Card>

      {/* 新增/编辑模态框 */}
      <Modal
        title={modalTitle}
        open={modalVisible}
        onOk={handleSubmit}
        onCancel={() => setModalVisible(false)}
        confirmLoading={loading}
        width={700}
      >
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="indicator_name"
                label="指标名称"
                rules={[{ required: true, message: "请输入指标名称" }]}
              >
                <Input placeholder="请输入指标名称" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="weight"
                label="权重"
                rules={[
                  { required: true, message: "请输入权重" },
                  {
                    type: "number",
                    min: 0,
                    max: 1,
                    message: "权重必须在0-1之间",
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  max={1}
                  step={0.01}
                  precision={4}
                  placeholder="请输入权重(0-1)"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="parent_id" label="父级指标">
                <Select placeholder="请选择父级指标(不选则为一级指标)">
                  <Option value={null}>无(一级指标)</Option>
                  {getParentOptions().map((item) => (
                    <Option key={item.indicator_id} value={item.indicator_id}>
                      {item.indicator_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="applicant_type"
                label="评价人类型"
                rules={[{ required: true, message: "请选择评价人类型" }]}
              >
                <Select placeholder="请选择评价人类型">
                  <Option value="管理员">管理员</Option>
                  <Option value="辅导员">辅导员</Option>
                  <Option value="教师">教师</Option>
                  <Option value="学生">学生</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item name="description" label="指标描述">
            <TextArea rows={4} placeholder="请输入指标描述" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
